<template>
    <tr class="budget-row-child with-description">
        <td :class="{'active': showDescription}" :colspan="colspan">
            <button v-on:click="toggleDescription" class="toggleDescription">
                <Icon :icon="descriptionIcon" />
            </button>
            {{ name }}
            <p class="description" colspan="3" v-html="description"></p>
        </td>
        <Cell 
            v-for="(budget, index) in totals" 
            :budget="budget" 
            :key="index + name"
        />
    </tr>
</template>

<script>
    import Cell from '@/components/Cell';
    import Icon from '@/components/Icon';

    export default {
        name: 'RowDescription',
        props: {
            'name' : String,
            'totals' : Object,
            'description': String
        },
        components: {
            Cell,
            Icon
        },
        data() {
            return {
                showDescription: false
            }
        },
        computed: {
            descriptionIcon() {
                return (this.showDescription) ? 'close' : 'info';
            },
            colspan() {
                return (this.showDescription) ?  Object.keys(this.totals).length + 1 : '1' ;
            }
        },
        methods: {
            toggleDescription() {
                this.showDescription = (this.showDescription) ? false : true;
            }
        }
    }
</script>

<style lang="scss">
    .toggleDescription {
        display: inline-block;
        width: 20px;
        height: 20px;
        padding: 0;
        background: transparent;
        border: 0px;

        svg {
            color:#003da5;
        }

        &:hover {
            svg {
                color:#000;
            }
        }
    }
    .description {
        padding-top:20px;
        display:none;
    }
    .active .description {
        display:table-cell;
    }
    .budget-row-child.with-description .active {
        ~ td:not(:first-child) {
                display:none;
        }
    } 
</style>
